// Fee-configuration vocabularies, hoisted from
// `packages/server/src/domain/types/TransactionFeeTypes.ts`. Admin restated
// two of the three as bare string unions.
//
// The `TransactionFee` record shape itself stays where it is: it is a type,
// not an enum, and belongs to the types shard.
export var AfriexTransactionFeePaymentMethod;
(function (AfriexTransactionFeePaymentMethod) {
    AfriexTransactionFeePaymentMethod["REGULATED_CARD"] = "REGULATED_CARD";
    AfriexTransactionFeePaymentMethod["UNREGULATED_CARD"] = "UNREGULATED_CARD";
})(AfriexTransactionFeePaymentMethod || (AfriexTransactionFeePaymentMethod = {}));
export var AfriexTransactionFeeType;
(function (AfriexTransactionFeeType) {
    /** Default applies to all transaction currencies. */
    AfriexTransactionFeeType["DEFAULT"] = "default";
    /**
     * Override is anything that overrides the default fee, e.g. an override for
     * a specific currency or payment method.
     */
    AfriexTransactionFeeType["OVERRIDE"] = "override";
})(AfriexTransactionFeeType || (AfriexTransactionFeeType = {}));
export var AfriexTransactionFeeLimitType;
(function (AfriexTransactionFeeLimitType) {
    AfriexTransactionFeeLimitType["ABOVE"] = "above";
    AfriexTransactionFeeLimitType["BELOW"] = "below";
})(AfriexTransactionFeeLimitType || (AfriexTransactionFeeLimitType = {}));
//# sourceMappingURL=AfriexTransactionFee.js.map